module.exports = __webpack_public_path__ + "img/ban3_.1a81f300.png";